@if (showShell()) {
  <div class="min-h-screen" [style.background]="'var(--app-bg)'">
    <app-sidebar />
    <main
      class="min-h-screen transition-[margin] duration-200"
      [style.margin-left]="layout.sidebarCollapsed() ? '64px' : '240px'"
    >
      <router-outlet />
    </main>
  </div>
} @else {
  <router-outlet />
}

<app-update-notice />
